// @flow
import styled from 'styled-components';
import Grid from 'styled-components-grid';
import breakpoint from 'styled-components-breakpoint';
import {
  mb, px, pt, p, mt, m, py, pb
} from 'styled-components-spacing';
import { fontCopyDefault } from '@styles/typography';
import theme from '@theme';

export const StyledCoverMaxWidthWrapper = styled.div`
  max-width: 1600px;
  margin: 0 auto;
  position: relative;
  ${pb(4)}
  ${breakpoint('desktop')`
    ${px(3)}
    ${mb(4)}
  `}
`;
export const StyledCover = styled.div`
  background-color: ${theme.colors.white};
  width: 100%;
  ${pt(4)}
`;

export const StyledHeadline = styled.h2`
  font-size: 30px;
  font-weight: bold;
  text-align: center;
  ${m(4)}
  ${breakpoint('mobile', 'desktop')`
font-size:22px;
`}
`;

export const StyledGrid = styled(Grid)`
  width: 100%;
  box-sizing: border-box;
  ${p(0)}

  ${breakpoint('desktop')`
    ${px(5)}
    ${py(3)}
    ${mt(2)}
  `}
`;

export const StyledGridUnit = styled(Grid.Unit)`
  ${px(4)}
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const StyledGraphImage = styled.img.attrs({ loading: 'lazy' })`
  width: 100%;
  height: auto;
  object-fit: contain;
  font-family: 'object-fit: contain;';
  max-width:500px;
  ${mb(4)}

  ${breakpoint('desktop')`
    ${mb(0)}
  `}
  ${breakpoint('tablet', 'desktop')`
  margin:auto;
  `}
`;

export const StyledDescriptionWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
`;

export const StyledText = styled.div`
  ${fontCopyDefault}
  ${p(3)};
  color: ${theme.colors.mediumGray};
`;

export const StyledLogoWrapper = styled.div`
  margin: auto 0;
  img {
    aspect-ratio: 1 /1;
    width: 50px;
    height: 100%;
    ${p(1)}
  }
`;

export const StyledButtonsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  font-weight: bold;
`;
export const StyledLearnButton = styled.div`
  ${m(3)};
  ${p(3)}
  ${px(4)};
  color: ${theme.colors.mediumGray};
  border: 1px solid #57a1bb;
  border-radius: 12px;
  cursor: pointer;
  :hover {
    background-color: #86d4ef;
    color: ${theme.colors.white};
  }
  ${breakpoint('mobile', 'tablet')`
  ${px(2)};
  ${m(2)}
  border-radius: 6px;
  `}
`;

export const StyledContactButton = styled.div`
  ${m(3)};
  ${p(3)};
  ${px(4)};
  color: ${theme.colors.white};
  border-color: 2px solid #57a1bb;
  border-radius: 8px;
  background-color: #57a1bb;
  cursor: pointer;
  :hover {
    color: ${theme.colors.mediumGray};
    background-color: white;
    border: 1px solid #57a1bb;
  }
  ${breakpoint('mobile', 'tablet')`
  ${px(2)};
  ${m(2)}
  border-radius: 6px;
  `}
`;
